import {Component, Input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Card} from 'primeng/card';
import {Button} from 'primeng/button';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-player-profile-pro-feature',
  imports: [
    TranslatePipe,
    Card,
    Button,
    RouterLink
  ],
  templateUrl: './player-profile-pro-feature.component.html',
  styleUrl: './player-profile-pro-feature.component.scss'
})
export class PlayerProfileProFeatureComponent
{
  @Input() label = 'PLAYER_PROFILE_FEATURE_REQUIRES_PRO';
  @Input() headerLabel = 'PLAYER_PROFILE';
  @Input() onlyLabel: boolean;
}
